export const CheckIcon = (props) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.7268 21.1667L6.16677 15.6067L4.27344 17.4867L11.7268 24.9401L27.7268 8.94006L25.8468 7.06006L11.7268 21.1667Z"
        fill="currentColor"
      />
    </svg>
  );
};
